import { gql } from "@apollo/client";

export const LIST_CATEGORY = gql`
  query listCategories($filter: CategoryFilter, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listCategories(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        description
        reference
        productCount
      }
    }
  }
`;

export const LIST_PRODUCTS = gql`
  query listProducts($filter: ProductFilter!, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listProducts(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        reference
        nameTranslations {
          language
          value
        }
        descriptionTranslations {
          value
          language
        }
        category {
          id
          name
        }
        archivedAt
        canBeDeleted
        vat {
          id
          rate
        }
        prices {
          currency {
            id
            code
            isMainCurrency
            decimalPlaces
            buyPrice {
              id
              total
            }
            priceNet {
              id
              net
            }
          }
        }
      }
    }
  }
`;

export const LIST_PRODUCTS_TYPES = gql`
  query listProductTypes(
    $filter: ProductTypeFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listProductTypes(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        code
      }
    }
  }
`;

export const LIST_PRODUCTS_TYPES_FOR_ASYNC_SELECT = gql`
  query listProductTypes(
    $companyId: ID!
    $search: String
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listProductTypes(filter: { search: $search, companyId: $companyId }) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        code
      }
    }
  }
`;

export const LIST_PRODUCTS_PRICE = gql`
  query listProductsPrice(
    $filter: ProductPriceFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listProductsPrice(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        createdAt
        net
        product {
          id
          name
          reference
          priceNet
          buyPriceTotal
        }
      }
    }
  }
`;
export const LIST_PRODUCTS_BUY_PRICE = gql`
  query listProductsBuyPrice(
    $filter: ProductBuyPriceFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listProductsBuyPrice(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        createdAt
        product {
          id
          name
          reference
          buyPriceTotal
        }
        total
      }
    }
  }
`;

export const LIST_PRODUCTS_FOR_ASYNC_SELECT = gql`
  query listProducts(
    $search: String
    $company: ID!
    $category: ID
    $saleDocumentId: ID
    $currency: String
    $showTtc: Boolean
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listProducts(
      filter: {
        name_Istartswith: $search
        category: $category
        saleDocumentId: $saleDocumentId
        currency: $currency
        company: $company
        showTtc: $showTtc
      }
    ) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        reference
        description
        category {
          id
          name
        }
        priceNet
        vat {
          id
          rate
          ratePercentage
        }
        unitMeasure {
          id
          name
          slug
        }
        descriptionTranslations {
          language
          value
        }
        nameTranslations {
          language
          value
        }
      }
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation createCategory($input: CategoryCreateInput!) {
    createCategory(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation updateCategory($input: CategoryUpdateInput!) {
    updateCategory(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_PRODUCT_BUY_PRICE = gql`
  mutation updateProductBuyPrice($input: ProductBuyPriceUpdateInput!) {
    updateProductBuyPrice(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const UPDATE_PRODUCT_PRICE = gql`
  mutation updateProductPrice($input: ProductPriceUpdateInput!) {
    updateProductPrice(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_PRODUCT = gql`
  query getProduct($id: ID!) {
    getProduct(id: $id) {
      id
      name
      priceNet
      reference
      description
      buyPriceTotal
      counterpartCode
      nameTranslations {
        language
        value
      }
      descriptionTranslations {
        language
        value
      }
      category {
        id
        name
        reference
      }
      vat {
        id
        name
        rate
        ratePercentage
        code
      }
      productType {
        id
        name
        code
      }
      operationalCategory {
        label
        value
      }
      unitMeasure {
        id
        name
        slug
      }
      prices {
        currency {
          id
          code
          isMainCurrency
          decimalPlaces
          buyPrice {
            id
            total
          }
          priceNet {
            id
            net
          }
        }
      }
    }
  }
`;

export const GET_CATEGORY = gql`
  query getCategory($id: ID!) {
    getCategory(id: $id) {
      id
      name
      reference
      description
      counterpartCode
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation createProduct($input: ProductCreateInput!) {
    createProduct(input: $input) {
      success
      errors {
        field
        messages
      }
      product {
        id
        name
        reference
        unitMeasure {
          id
          slug
          name
        }
        nameTranslations {
          language
          value
        }
        descriptionTranslations {
          language
          value
        }
        vat {
          id
          name
          rate
          ratePercentage
          code
        }
        priceNet
        description
        prices {
          currency {
            id
            isActive
            isMainCurrency
            priceNet {
              net
            }
            buyPrice {
              total
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation updateProduct($input: ProductUpdateInput!) {
    updateProduct(input: $input) {
      success
      errors {
        field
        messages
      }
      product {
        id
      }
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation deleteCategory($id: ID!) {
    deleteCategory(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const ARCHIVE_PAYMENT_DEADLINE = gql`
  mutation archiveCompanyPaymentDeadline($id: ID!) {
    archiveCompanyPaymentDeadline(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const REACTIVATE_PAYMENT_DEADLINE = gql`
  mutation reactivateCompanyPaymentDeadline($id: ID!) {
    reactivateCompanyPaymentDeadline(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation deleteProduct($id: ID!) {
    deleteProduct(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const ARCHIVE_PRODUCT = gql`
  mutation archiveProduct($id: ID!) {
    archiveProduct(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const REACTIVATE_PRODUCT = gql`
  mutation reactivateProduct($id: ID!) {
    reactivateProduct(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const LIST_COMMENTS = gql`
  query listComments($filter: CommentFilter, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listComments(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        reference
        description
      }
    }
  }
`;

export const GET_COMMENT = gql`
  query getComment($id: ID!) {
    getComment(id: $id) {
      id
      name
      reference
      description
    }
  }
`;

export const CREATE_COMMENT = gql`
  mutation createComment($input: CommentCreateUpdateInput!) {
    createComment(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_COMMENT = gql`
  mutation updateComment($input: CommentCreateUpdateInput!) {
    updateComment(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_COMMENT = gql`
  mutation deleteComment($id: ID!) {
    deleteComment(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const LIST_COMMENTS_FOR_ASYNC_SELECT = gql`
  query listComments(
    $search: String
    $companyId: ID!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listComments(filter: { search: $search, companyId: $companyId }) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        reference
        description
      }
    }
  }
`;

export const LIST_PRODUCT_OPERATIONAL_CATEGORIES = gql`
  query {
    listProductOperationalCategories: listProductOperationalCategories {
      label
      value
    }
  }
`;
